import {LoginResultRecord} from "@commons/mapping/LoginResultRecord";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";

export type AppStatus = 'BOOT' | 'READY' | 'RUN' | 'ISEXPIRING' | 'EXPIRED' | 'PWD_EXPIRED' | 'FIRST_LOGIN' | 'WAITINGFORACTIVATION';

export type RifContratto = Pick<LavoratoreRecord, 'id' | 'idAziendaMaster' | 'idAzienda'>;
export const contrattoNullo: RifContratto = {
    idAziendaMaster: 0,
    idAzienda: 0,
    id: 0, // id contratto (alias idDip)
};

interface PersistData {
    token: string,
    userName: string,
    contratto: RifContratto,
    showModalVideo: boolean,
}

export interface CoreState {
    status: AppStatus,
    isBusy: boolean,
    loginResult: LoginResultRecord,
    firstLogin: boolean,
    passwordExpired: boolean,
    aziendaNavLink: string | null,
    azienda: AziendaRecord | null,
    aziendaMaster: AziendaRecord | null,
    contratto: LavoratoreRecord | null, // Contratto corrente
    nextContratto: RifContratto | null, // prossimo contratto a essere selezionato (da locale storage, valido solo dopo refresh F5)
    persistData: PersistData,
}

export const initialState: CoreState = {
    status: 'BOOT',
    isBusy: false,
    loginResult: {} as LoginResultRecord,
    aziendaNavLink: null,
    azienda: null,
    aziendaMaster: null,
    contratto: null,
    nextContratto: null,
    firstLogin: false,
    passwordExpired: false,
    persistData: {token: '', userName: '', contratto: contrattoNullo, showModalVideo: true},
};
